/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationactiondismiss2Inputs */

const en_moderationactiondismiss2 = /** @type {(inputs: Moderationactiondismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const de_moderationactiondismiss2 = /** @type {(inputs: Moderationactiondismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerfen`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Moderationactiondismiss2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationactiondismiss2 = /** @type {((inputs?: Moderationactiondismiss2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationactiondismiss2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationactiondismiss2(inputs)
	return de_moderationactiondismiss2(inputs)
});
export { moderationactiondismiss2 as "moderationActionDismiss" }